export default "__VITE_ASSET__d1180ef9__"